import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "sidebar" }
const _hoisted_3 = {
  key: 0,
  class: "preview"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_spinner = _resolveComponent("loading-spinner")!
  const _component_prototype_tile_component = _resolveComponent("prototype-tile-component")!
  const _component_prototype_component = _resolveComponent("prototype-component")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("aside", _hoisted_2, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_loading_spinner, { key: 0 }))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.prototypes, (item, index) => {
            return (_openBlock(), _createBlock(_component_prototype_tile_component, {
              key: index,
              prototype: item,
              "selected-index": _ctx.selected,
              "is-selected": _ctx.selected === index,
              "is-expanded": _ctx.expanded === index,
              "sub-mass-notif-index": _ctx.subMassNotifSelected,
              "sub-notice-index": _ctx.subNoticeSelected,
              "sub-invitation-index": _ctx.subInvitationSelected,
              onSelect: ($event: any) => (_ctx.handleSelected(index)),
              onSelectMassNotifChild: _ctx.handleSubMassNotifSelected,
              onSelectNoticeChild: _ctx.handleSubNoticeSelected,
              onSelectInvitationChild: _ctx.handleSubInvitationSelected
            }, null, 8, ["prototype", "selected-index", "is-selected", "is-expanded", "sub-mass-notif-index", "sub-notice-index", "sub-invitation-index", "onSelect", "onSelectMassNotifChild", "onSelectNoticeChild", "onSelectInvitationChild"]))
          }), 128))
    ]),
    (_ctx.selectedPrototype && !_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_prototype_component, { prototype: _ctx.selectedPrototype }, null, 8, ["prototype"])
        ]))
      : _createCommentVNode("", true)
  ]))
}